// Generated from the original Kaya PWA by scripts/extract-data.js — do not reformat by hand.
// The words are domain/cycleWords.ts's, not the reference's (ADR-057).
import { PHASE_WORDS } from "../domain/cycleWords";
import type { CyclePhaseDef } from "../domain/types";

const words = (id: CyclePhaseDef["id"]) => {
  const { what, good, easy } = PHASE_WORDS[id];
  return { what, good, easy };
};

export const PHASES: CyclePhaseDef[] = [
 {id:"menstrual",n:"Menstrual",c:"#c94f7c",...words("menstrual")},
 {id:"follicular",n:"Follicular",c:"#5fc2a6",...words("follicular")},
 {id:"ovulation",n:"Ovulation",c:"#e6b35a",...words("ovulation")},
 {id:"luteal",n:"Luteal",c:"#7fb3e0",...words("luteal")}
];
